import React, {ReactElement, useEffect, useState} from "react";
import {TILE_SIZE} from "@components/core/theme";

const OUTER = 0;
const BAND  = 6;
const CELL  = TILE_SIZE.x;
const INNER = OUTER + BAND;
export const MAP_BORDER_INSET = INNER;
const DARK  = "#3d2b1f";
const LIGHT = "#ffffff";

function borderTiles(pw: number, ph: number): ReactElement[] {
    const tiles: ReactElement[] = [];
    let k = 0;
    const c = (i: number) => i % 2 === 0 ? DARK : LIGHT;

    let hN = Math.ceil((pw - OUTER * 2) / CELL);
    if (hN % 2 === 0) hN++;
    const hStart = OUTER - (hN * CELL - (pw - OUTER * 2)) / 2;

    let vN = Math.ceil((ph - (OUTER + BAND) * 2) / CELL);
    if (vN % 2 === 0) vN++;
    const vStart = (OUTER + BAND) - (vN * CELL - (ph - (OUTER + BAND) * 2)) / 2;

    for (let i = 0; i < hN; i++) {
        const x1 = Math.max(hStart + i * CELL, OUTER);
        const x2 = Math.min(hStart + (i + 1) * CELL, pw - OUTER);
        tiles.push(<rect key={k++} x={x1} y={OUTER} width={x2 - x1} height={BAND} fill={c(i)}/>);
        tiles.push(<rect key={k++} x={x1} y={ph - OUTER - BAND} width={x2 - x1} height={BAND} fill={c(i)}/>);
    }

    for (let i = 0; i < vN; i++) {
        const y1 = Math.max(vStart + i * CELL, OUTER + BAND);
        const y2 = Math.min(vStart + (i + 1) * CELL, ph - OUTER - BAND);
        tiles.push(<rect key={k++} x={OUTER} y={y1} width={BAND} height={y2 - y1} fill={c(i)}/>);
        tiles.push(<rect key={k++} x={pw - OUTER - BAND} y={y1} width={BAND} height={y2 - y1} fill={c(i)}/>);
    }

    return tiles;
}

function getBottomBarHeight(): number {
    const el = document.querySelector("[data-draggable='bottombar']");
    return el ? el.getBoundingClientRect().height : 0;
}

export function MapBorder() {
    const [w, setW] = useState(window.innerWidth);
    const [h, setH] = useState(window.innerHeight);
    const [bottomBarHeight, setBottomBarHeight] = useState(getBottomBarHeight);

    useEffect(() => {
        const update = () => {
            setW(window.innerWidth);
            setH(window.innerHeight);
            setBottomBarHeight(getBottomBarHeight());
        };
        window.addEventListener("resize", update);

        // Poll briefly after mount for the bottom bar to render
        const t = setTimeout(update, 200);
        return () => {
            window.removeEventListener("resize", update);
            clearTimeout(t);
        };
    }, []);

    const mapH = h - bottomBarHeight;

    return (
        <svg width={w} height={mapH} style={{
            position: "absolute",
            top: 0,
            left: 0,
            pointerEvents: "none",
            touchAction: "none",
            zIndex: 190
        }}>
            {borderTiles(w, mapH)}
            <rect x={OUTER} y={OUTER} width={w - OUTER * 2} height={mapH - OUTER * 2}
                  fill="none" stroke={DARK} strokeWidth="2"/>
            <rect x={INNER} y={INNER} width={w - INNER * 2} height={mapH - INNER * 2}
                  fill="none" stroke={DARK} strokeWidth="2"/>
            <rect x={INNER + 4} y={INNER + 4} width={w - (INNER + 4) * 2} height={mapH - (INNER + 4) * 2}
                  fill="none" stroke={DARK} strokeWidth="1"/>
        </svg>
    );
}
